import { render, staticRenderFns } from "./ProcessList.vue?vue&type=template&id=b7fdf84a&scoped=true&"
import script from "./ProcessList.vue?vue&type=script&lang=js&"
export * from "./ProcessList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7fdf84a",
  null
  
)

export default component.exports